import AdminPanel from "@/components/feature/AdminPanel";
import { Link } from "react-router-dom";
import { useState } from "react";

export default function Footer() {
  const [copied, setCopied] = useState(false);

  const handleCopyEmail = async () => {
    try {
      await navigator.clipboard.writeText("siljeon.jp@gmail.com");
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // fallback: ignore
    }
  };
  return (
    <footer className="bg-secondary-100 border-t border-background-200">
      <div className="max-w-6xl mx-auto px-4 md:px-10 py-6 sm:py-12 flex flex-col md:flex-row md:items-start md:justify-between gap-8">
        <div>
          <div className="flex items-center gap-2">
            <span className="w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center rounded-full bg-primary-500 text-background-50 font-heading text-base sm:text-lg">
              日
            </span>
            <span className="font-heading text-base sm:text-lg font-bold text-foreground-950">
              실전 일본어 연구소
            </span>
          </div>
          <p className="mt-3 text-xs sm:text-sm text-foreground-700 max-w-sm leading-relaxed">
            &ldquo;이해하고, 직접 말하는 일본어&rdquo;를 목표로 하는 소수정예 온라인 일본어 클래스.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8 text-sm">
          <div>
            <h4 className="font-heading font-bold text-foreground-950 mb-3">바로가기</h4>
            <ul className="space-y-2 text-foreground-700">
              <li>
                <a href="#intro" className="hover:text-primary-600 whitespace-nowrap">
                  수업 소개
                </a>
              </li>
              <li>
                <a href="#curriculum" className="hover:text-primary-600 whitespace-nowrap">
                  커리큘럼
                </a>
              </li>
              <li>
                <a href="#info" className="hover:text-primary-600 whitespace-nowrap">
                  수업 안내
                </a>
              </li>
              <li>
                <a href="#faq" className="hover:text-primary-600 whitespace-nowrap">
                  FAQ
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-heading font-bold text-foreground-950 mb-3">문의</h4>
            <ul className="space-y-2 text-foreground-700">
              <li>
                <button
                  onClick={handleCopyEmail}
                  className="flex items-center gap-2 hover:text-primary-600 transition-colors cursor-pointer text-left"
                >
                  <i className="ri-mail-line"></i>
                  {copied ? "복사 완료!" : "siljeon.jp@gmail.com"}
                </button>
              </li>
              <li>
                <a
                  href="http://pf.kakao.com/_VxdxgxnX"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 hover:text-primary-600 transition-colors"
                >
                  <i className="ri-kakao-talk-fill"></i> 카카오채널 문의하기
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/siljeon.jp_lab/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 hover:text-primary-600 transition-colors"
                >
                  <i className="ri-instagram-line"></i> @siljeon.jp_lab
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line"></i> 평일 10:00 - 18:00
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="border-t border-background-200/70">
        <div className="max-w-6xl mx-auto px-4 md:px-10 py-3 sm:py-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-foreground-600">
          <span className="break-all text-center sm:text-left">© 2026 실전 일본어 연구소. All rights reserved.</span>
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1">
            <Link to="/privacy" className="hover:text-primary-600 whitespace-nowrap">
              개인정보 처리방침
            </Link>
            <span className="text-foreground-400">|</span>
            <Link to="/terms" className="hover:text-primary-600 whitespace-nowrap">
              이용약관
            </Link>
            <span className="break-all">
              Made with care for real Japanese learners<AdminPanel>.</AdminPanel>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}